import { Box, type PositionProps, type BoxProps } from "@chakra-ui/react";
import React from "react";
import { Link } from "ui/link";

type SuperscriptProps = {
  size: "sm" | "md" | "lg";

  /**
   * @default "1"
   */
  text?: string;

  href: string;
} & PositionProps;

/**
 * A text component used to display a superscript reference link.
 */
export function Superscript({ size, text = "1", href, ...positionProps }: SuperscriptProps) {
  let fontSize: BoxProps["fontSize"];
  let top: BoxProps["top"];
  let textUnderlineOffset: BoxProps["textUnderlineOffset"];

  switch (size) {
    case "sm": {
      fontSize = "brand.xs";
      top = "-1.15em";
      textUnderlineOffset = "2px";
      break;
    }

    case "md": {
      fontSize = { base: "brand.xs", md: "brand.sm" };
      top = "-1.25em";
      textUnderlineOffset = "2px";
      break;
    }

    case "lg": {
      fontSize = { base: "brand.sm", md: "brand.md" };
      top = "-1.5em";
      break;
    }

    // No default
  }

  return (
    <Box as="sup" letterSpacing="0" fontSize={fontSize} top={top} {...positionProps}>
      <Link href={href} variant="inlineDark" target="_blank" textUnderlineOffset={textUnderlineOffset}>
        {text}
      </Link>
    </Box>
  );
}
